import React from "react";
import type { ColorSource, Graphics as PixiGraphics } from "pixi.js";
import { colorNameMap, useFocused } from "@poscon/shared-frontend";
import { Rectangle } from "pixi.js";
import { bottomRightBorderColor, topLeftBorderColor } from "~/utils/constants";

export type RadioButtonProps = {
  x?: number;
  y?: number;
  size?: number;
  borderSize?: number;
  borderTint?: ColorSource;
  selectedTint?: ColorSource;
  selected: boolean;
  disabled?: boolean;
  variant?: "circle" | "square" | "diamond";
  onmousedown?: () => void;
};

export const RadioButton = ({
  x = 0,
  y = 0,
  selected,
  onmousedown,
  size = 8,
  borderSize = 1,
  disabled = false,
  borderTint = colorNameMap.darkGrey,
  selectedTint = colorNameMap.grey,
  variant = "circle",
}: RadioButtonProps) => {
  const ref = React.useRef<PixiGraphics>(null);
  const focused = useFocused(ref);

  return (
    <graphics
      ref={ref}
      x={x}
      y={y}
      eventMode={disabled ? "none" : "static"}
      onMouseDown={onmousedown}
      angle={variant === "diamond" ? 45 : 0}
      hitArea={new Rectangle(-size / 2, -size / 2, size, size)}
      draw={(graphics) => {
        graphics.clear();
        switch (variant) {
          case "circle":
            graphics
              .circle(0, 0, Math.floor(size / 2))
              .fill(selected ? selectedTint : 0)
              .stroke({ width: borderSize, color: focused ? colorNameMap.white : borderTint });
            break;
          case "square":
          case "diamond":
            graphics
              .rect(-5, -5, 10, 10)
              .fill(selected ? 0xf0f0f0 : 0x000000)
              .stroke({ width: 2, color: selected ? bottomRightBorderColor : topLeftBorderColor });
            graphics
              .moveTo(5, -5)
              .lineTo(5, 5)
              .lineTo(-5, 5)
              .stroke({ width: 2, color: selected ? topLeftBorderColor : bottomRightBorderColor });
        }
      }}
    />
  );
};
